// extracted by mini-css-extract-plugin
export default {"title":"intro-section_title__ZhPks"};